<div
  class="shopping-cart"
  (mouseenter)="onMouseHover()"
  (mouseleave)="onMouseLeave()"
  fxLayout="column"
  [ngClass]="{
    'shopping-cart__visible': showMiniCart$,
    'shopping-cart__invisible': !showMiniCart$,
    'navigation-bar-enabled': isNavigationuBarEnabledV2
  }"
  [mmTestTarget]="'shopping-cart'"
>
  <div class="shopping-cart__header">
    <h4 class="shopping-cart__title">{{ 'CART.TITLE' | translate }}</h4>
    <ng-container *ngIf="deleteFlag">
      <div class="shopping-cart__message">
        <a class="shopping-cart__productLink" [routerLink]="productRoute">
          <span (click)="trackProductNameClick(deletedProduct); handleProductClick($event, productId)">
            {{ productName }}
          </span>
        </a>
        <span test-target="mini-shopping-cart-remove-success">{{ 'CART.NOTIFICATION.REMOVE_SUCCESS' | translate }}</span
        >.
      </div>
      <a *ngIf="showUndoOption" class="shopping-cart__undoLink" (click)="undoLastDeleteFromCart()">
        {{ 'CART.EMPTY_CART.UNDO.TITLE' | translate }}
      </a>
      <div class="shopping-cart__line"></div>
    </ng-container>
  </div>
  <div class="wrapper">
    <div
      (scroll)="onScroll($event)"
      class="shopping-cart__itemContainer"
      [ngClass]="{
        'shopping-cart__itemContainer__expanded': showMiniCart$ && !!shoppingCartData?.offers?.length && !deleteFlag,
        'shopping-cart__itemContainer__expanded-with-delete':
          showMiniCart$ && !!shoppingCartData?.offers?.length && deleteFlag
      }"
    >
      <div fxLayout="column" *ngFor="let offer of shoppingCartData?.offers">
        <div class="shopping-cart__content" fxLayout="row" fxLayoutGap="12px" test-target="minicart-offer-item">
          <a [routerLink]="[productLink, offer.item.id]" [queryParams]="{ offerId: offer.offer }">
            <span (click)="onClickCloseCart(); handleProductClick($event, offer.item.id, '?offerId=' + offer.offer)">
              <img
                loading="lazy"
                class="shopping-cart__image"
                [src]="offer.imageUrl"
                height="84px"
                width="84px"
                test-target="mini-shopping-cart-product-image"
              />
              <div *ngIf="offer.item?.attributes?.energy_config || offer.item?.attributes?.energyEfficiencyClass" class="shopping-cart__energy-label">
                <app-search-product-energy-efficiency-new
                  [energyEfficiencyClass]="this.offer.item?.attributes?.energyEfficiencyClass"
                  [energyEfficiencyRange]="this.offer.item?.attributes?.energyEfficiencyRange"
                  [energyEfficiencyImage]="this.offer.item?.attributes?.energyEfficiencyImage"
                  [energyConfig]="this.offer.item?.attributes?.energy_config"
                  [productId]="this.offer.item?.productId"
                >
                </app-search-product-energy-efficiency-new>
              </div>
            </span>
          </a>
          <div class="shopping-cart__details" fxLayout="column" fxLayoutAlign="space-between">
            <div fxLayout="row" fxLayoutAlign="space-between">
              <div>
                <a
                  [routerLink]="[productLink, offer.item.id]"
                  [queryParams]="{ offerId: offer.offer }"
                  class="shopping-cart__name"
                  test-target="mini-shopping-cart-product-name"
                >
                  <span
                    (click)="
                      trackProductNameClick(offer.item.id);
                      handleProductClick($event, offer.item.id, '?offerId=' + offer.offer)
                    "
                  >
                    {{ offer.item.name }}
                  </span>
                </a>
                <span
                  *ngIf="offer.item?.hasPromotion && !offer.trackingData?.referencePrice"
                  class="shopping-cart__deal-label"
                >
                  {{ 'CORE.ALL_PAGES.PRODUCT_PROMO.LABEL' | translate }}
                </span>
              </div>
              <a class="shopping-cart__delete" (click)="onRemove(offer)" test-target="mini-shopping-cart-trash">
                <mm-icon name="trash"></mm-icon>
              </a>
            </div>
            <div class="shopping-cart__price" fxLayout="column" fxLayoutAlign="end end">
              <div
                class="priceBox"
                [ngClass]="{ 'shopping-cart__animate': (isQuantityUpdate | async) && productId === offer?.item?.id }"
              >
                <span class="quantity" test-target="mini-shopping-cart-product-quantity"
                  >{{ 'CORE.ALL_PAGES.HEADER.SHOPPING_CART.QUANTITY' | translate }}: {{ offer.quantity }}</span
                >
                <span class="shopping-cart__itemPrice price" test-target="mini-shopping-cart-product-price">
                  <span
                    *ngIf="isConsumer && offer.trackingData?.referencePrice"
                    class="referencePrice"
                    test-target="mini-cart-ref-price"
                  >
                    {{
                      offer.trackingData?.referencePrice?.totalGross * offer.quantity
                        | currency: offer.trackingData?.referencePrice?.currency
                    }}
                  </span>
                  <span
                    *ngIf="!isConsumer && offer.trackingData?.referencePrice"
                    class="referencePrice"
                    test-target="mini-cart-ref-price"
                  >
                    {{
                      offer.trackingData?.referencePrice?.totalNet * offer.quantity
                        | currency: offer.trackingData?.referencePrice?.currency
                    }}
                  </span>
                  <span *ngIf="isConsumer" [ngClass]="{ 'price-color': offer.trackingData?.referencePrice }">
                    {{
                      (+offer.price.offer + +offer.price.offerTax) * offer.quantity
                        | currency: shoppingCartData?.currency
                    }}
                  </span>
                  <span *ngIf="!isConsumer" [ngClass]="{ 'price-color': offer.trackingData?.referencePrice }">
                    {{ offer.price.offer * offer.quantity | currency: shoppingCartData?.currency }}
                  </span>
                </span>
              </div>
              <div [ngClass]="offer?.minQuantity > 1 ? 'priceBox ' : ''">
                <span
                  test-target="min-quantity-line"
                  *ngIf="offer?.minQuantity > 1"
                  class="shopping-cart__minQuantity"
                  >{{
                    'CATALOG.DETAILS_PAGE.MINIMUM_QUANTITY.LABEL' | translate: { quantity: offer?.minQuantity }
                  }}</span
                >
                <div class="shopping-cart__vatPriceContainer">
                  <span *ngIf="!isConsumer; else vatIncluded" class="shopping-cart__vatPrice">
                    {{
                      'CORE.ALL_PAGES.HEADER.SHOPPING_CART.VAT'
                        | translate
                          : {
                              price: (offer?.price?.subTotalWithTaxes | currency: shoppingCartData?.currency)
                            }
                    }}</span
                  >
                  <ng-template #vatIncluded>
                    <span [ngClass]="!(offer?.minQuantity > 1) ? 'shopping-cart__vatPrice' : ''">
                      {{ 'CATALOG.DETAILS_PAGE.BUYBOX.PRICE_BOX.VAT_INCLUDED' | translate }}</span
                    >
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ng-container *ngIf="offer.invalidParams?.length > 0">
          <p class="shopping-cart__oos__message">{{ 'CATALOG.DETAILS_PAGE.BUYBOX.OUT_OF_STOCK.TITLE' | translate }}</p>
          <p class="shopping-cart__oos__advice">
            {{ 'CART.WARNNING.QUANTITY_ERROR_PREFIX' | translate }}
            <a [routerLink]="[productLink, offer.item.id]" [queryParams]="{ offerId: offer.offer }">
              <span (click)="handleProductClick($event, offer.item.id, '?offerId=' + offer.offer)">
                {{ 'CART.WARNNING.QUANTITY_ERROR_LINK' | translate }}
              </span>
            </a>
            {{ 'CART.WARNNING.QUANTITY_ERROR.SUFFIX' | translate }}
          </p>
        </ng-container>
        <div class="shopping-cart__line"></div>
      </div>
    </div>
    <div [ngClass]="{ 'shopping-cart__overflow': shoppingCartOverflow }">
      <div
        fxLayout="column"
        class="shopping-cart__total"
        [ngClass]="{ 'shopping-cart__total__expanded': showMiniCart$ && !!shoppingCartData?.offers?.length }"
      >
        <div fxLayout="row" fxLayoutAlign="space-between start">
          <span class="shopping-cart__label">{{ 'CART.TOTALS.SUBTOTAL' | translate }}</span>
          <span class="shopping-cart__subTotalPrice" *ngIf="isConsumer">
            {{
              +shoppingCartData?.totals?.subTotal + +shoppingCartData?.totals?.subTotalTax
                | currency: shoppingCartData?.currency
            }}
          </span>
          <span class="shopping-cart__subTotalPrice" *ngIf="!isConsumer">
            {{ shoppingCartData?.totals?.subTotal | currency: shoppingCartData?.currency }}
          </span>
        </div>
        <div
          *ngIf="(isValueAddedServicesFFEnabled$ | async) && hasValueAddedServices()"
          fxLayout="row"
          fxLayoutAlign="space-between start"
          test-target="additional-service-line"
        >
          <span class="shopping-cart__label">{{ 'CART.TOTALS.VALUE_ADDED_SERVICES.TITLE' | translate }}</span>
          <span
            *ngIf="cartData?.totals?.valueAddedServicesTotal !== '0'; else freeValueAddedServices"
            class="shopping-cart__subTotalPrice"
          >
            {{
              (isConsumer ? cartData?.totals?.valueAddedServicesTotal : cartData?.totals?.valueAddedServicesTotalNet)
                | currency: (currency$ | async)
            }}
          </span>
        </div>
        <div *ngIf="isConsumer" fxLayout="row" fxLayoutAlign="space-between start">
          <span class="shopping-cart__label">{{
            'CATALOG.DETAILS_PAGE.BUYBOX.SHIPPING.NEW.LAYOUT.TITLE' | translate
          }}</span>
          <span
            *ngIf="shoppingCartData?.totals?.shippingCostTotal !== '0'; else freeShipping"
            class="shopping-cart__subTotalPrice"
          >
            {{ shoppingCartData?.totals?.shippingCostTotal | currency: shoppingCartData?.currency }}
          </span>
        </div>
        <div *ngIf="!isConsumer" fxLayout="row" fxLayoutAlign="space-between start">
          <span class="shopping-cart__label">{{
            'CATALOG.DETAILS_PAGE.BUYBOX.SHIPPING.NEW.LAYOUT.TITLE' | translate
          }}</span>
          <span
            *ngIf="shoppingCartData?.totals?.netShippingCostTotal !== '0'; else freeShipping"
            class="shopping-cart__subTotalPrice"
          >
            {{ shoppingCartData?.totals?.netShippingCostTotal | currency: shoppingCartData?.currency }}
          </span>
        </div>
        <div *ngIf="!isConsumer" fxLayout="row" fxLayoutAlign="space-between start">
          <span class="shopping-cart__label">{{ 'CART.TOTALS.TAXES' | translate }}</span>
          <span class="shopping-cart__subTotalPrice" test-target="mini-shopping-cart-tax-total">
            {{ shoppingCartData?.totals?.totalTax | currency: shoppingCartData?.currency }}
          </span>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-between start">
          <span class="shopping-cart__totalLabel">{{ 'CART.TOTALS.TOTAL' | translate }}</span>
          <span class="shopping-cart__totalPrice" test-target="mini-shopping-cart-price-total">
            {{
              (isConsumer ? shoppingCartData?.totals?.total : shoppingCartData?.totals?.totalNet)
                | currency: shoppingCartData?.currency
            }}
          </span>
        </div>
        <span *ngIf="!isConsumer; else vatIncluded" class="shopping-cart__vatPrice" fxLayoutAlign="end end">
          {{
            'CORE.ALL_PAGES.HEADER.SHOPPING_CART.VAT'
              | translate
                : {
                    price: (shoppingCartData?.totals?.total | currency: shoppingCartData?.currency)
                  }
          }}
        </span>
        <button cartLink (click)="onClickGoToCart()" class="shopping-cart__button" color="primary" mm-button>
          {{ 'CORE.ALL_PAGES.HEADER.SHOPPING_CART.BUTTON_LABEL' | translate }}
        </button>
      </div>

      <ng-template #vatIncluded>
        <span fxLayoutAlign="end end" class="shopping-cart__vatPrice">
          {{ 'CATALOG.DETAILS_PAGE.BUYBOX.PRICE_BOX.VAT_INCLUDED' | translate }}
        </span>
      </ng-template>

      <ng-template #freeShipping>
        <span class="shopping-cart__shipping">
          {{ 'CORE.ALL_PAGES.HEADER.SHOPPING_CART.SHIPPING_FREE' | translate }}
        </span>
      </ng-template>
      <ng-template #freeValueAddedServices>
        <span class="shopping-cart__vas">
          {{ 'CORE.ALL_PAGES.HEADER.SHOPPING_CART.VAS_FREE' | translate }}
        </span>
      </ng-template>
    </div>
  </div>
  <app-mini-shopping-cart-empty
    *ngIf="!shoppingCartData?.offers?.length"
    [expanded]="showMiniCart$ && !shoppingCartData?.offers?.length"
    [deleteFlag]="deleteFlag"
    [undoCart]="undoCart"
    [catalogRoute]="catalogRoute"
    [queryParams]="queryParams"
    (closeCart)="onClickCloseCart()"
  >
  </app-mini-shopping-cart-empty>
</div>
